import { render, staticRenderFns } from "./Xue.vue?vue&type=template&id=4392607a&scoped=true&"
import script from "./Xue.vue?vue&type=script&lang=js&"
export * from "./Xue.vue?vue&type=script&lang=js&"
import style0 from "./Xue.vue?vue&type=style&index=0&id=4392607a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4392607a",
  null
  
)

export default component.exports